import { AbstractControl } from '@angular/forms';

export function IDFormatBeneficiaryValidator(control: AbstractControl) {
  if (control.parent) {
    const idType = control.parent.get('beneficiaryPersonDocumentType')?.value;
    if (idType === 'national id') {
      const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(control.value);
      if (!numbersOnly) {
        return {
          numbersOnly: true,
        };
      }
    } else if (idType === 'foreigner card') {
      //Verified from https://sel.migraciones.gob.pe/servmig-valreg/VerificarCE
      const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(control.value);
      if (!numbersOnly) {
        return {
          numbersOnly: true,
        };
      }
    }
  }
}
